import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { useForm } from "react-hook-form";
import FeedLogo from "./component/FeedLogo";
import FeedButton from "./component/FeedButton";
import {
  FlashMessage,
  Button,
  ErrorTextHelper,
} from "../../../components/common";
import cameraIcon from "../../../assets/svg/camera.svg";
import WriteWithAIEditIcon from "../../../assets/svg/write-with-ai-edit.svg";
import Image from "../../../components/common/Image";
import { aiTextToQuillHtml, stripHTMLTags } from "../../../utils/helper";
import useSessionUser from "../../../hooks/useSessionUser";
import { POST_MEDIA_UPLOAD_LIMIT } from "../../../utils/appConstants";
import Modal from "../../../components/common/Modal";
import httpRequest from "../../../utils/httpRequest";
import API_URLS from "../../../utils/apiUrls";
import Checkbox from "../../../components/common/Checkbox";
import Slider from "@material-ui/core/Slider";
import IconButton from "@material-ui/core/IconButton";
import {
  DeleteOutlined as DeleteIcon,
  OutlinedFlagOutlined as OutlinedFlagOutlinedIcon,
  Flare as FlareIcon,
  Cancel as CancelOut,
} from "@material-ui/icons";
import output from "../../../../src/assets/images/output-onlinegiftools.gif";
import ScheduleModel from "../components/ScheduleModel";
import { CircularProgress, Tooltip } from "@material-ui/core";
import ScheduleIcon from "@material-ui/icons/Schedule";
import appRoutes from "../../../routes/app.routes";
import { useNavigate } from "react-router-dom";
import CommonVideoModal from "../../../components/common/CoverImage";
import RichTextEditor from "../../../components/common/PostRichTextEditor";
import LinkPreviewCard, {
  LinkPreviewData,
} from "../../../components/common/LinkPreviewCard";
import { getLinkPreview } from "../../../services/feedPage.services";
import { generateVideoThumbnails } from "../../../utils/videoThumbnails";
import EmployHERName from "../../../components/common/EmployHERName";

type FormFields = {
  post_media: any;
  post_text: string;
  video_cover: any;
};
interface MediaAsset {
  file: File;
  url: string;
  type: string;
  thumbnails?: string[];
  selectedCover?: string;
  loadingThumbnails?: boolean;
}
interface IProps {
  slug?: string;
  showEditButton?: boolean;
  showShareButton?: boolean;
  showDeleteButton?: boolean;
  picturePath?: string;
  isUploading?: boolean;
  loading?: boolean;
}

const AI_TONE_OPTIONS = [
  { value: "SoundCausal", label: "Casual" },
  { value: "SoundProfessional", label: "Professional" },
  { value: "MakeItFriendly", label: "Friendly" },
  { value: "MakeItDirect", label: "Direct" },
  { value: "MakeItAssertive", label: "Assertive" },
  { value: "MakeItPersuasive", label: "Persuasive" },
  { value: "SoundConfident", label: "Confident" },
  { value: "MakeItLuxury", label: "Luxury" },
  { value: "MakeItEmpathetic", label: "Empathetic" },
  { value: "MakeItConstructive", label: "Constructive" },
  { value: "MakeItDiplomatic", label: "Diplomatic" },
  { value: "MakeItInspirational", label: "Inspirational" },
] as const;
function FeedPost(props: IProps) {
  // const dispatch = useDispatch();
  const {
    currentUser,
    IS_COMPANY,
    userProfile,
    userFullName,
    currentCompanyName,
    currentCompanyLogo,
    currentCompanySlug,
  } = useSessionUser();

  const postForm = useForm<FormFields>();
  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
    setValue,
  } = postForm;
  const [uploadImage, setUploadImage] = useState<any>([]);
  const [uploadVideo, setUploadVideo] = useState<any>([]);
  const [uploadAssets, setUploadAssets] = useState<MediaAsset[]>([]);
  const [postTextLength, setPostTextLength] = useState<number>(0);
  const [overflow, setOverflow] = useState(false);
  const [showAIModal, setShowAIModal] = useState<boolean>(false);
  const [specify, setSpecify] = useState<any>("SoundCausal");
  const [questions, setQuestion] = useState<any>([]);
  const [responseAiData, setResponseAiData] = useState<any>("");
  const [hash, setHash] = useState<boolean>(false);
  const [wordsLimit, setWordLimit] = useState<number>(50);
  const [loading, setLoading] = useState<boolean>(false);
  const [AIflag, setAIflag] = useState<boolean>(false);
  const [pendingAiHtml, setPendingAiHtml] = useState<string>("");
  const [scheduleShowModel, setScheduleShowModal] = useState(false);
  // const [schedule, setSchedule] = useState<string | null>();
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number | null>(
    null
  );
  const [scheduleValue, setScheduleValue] = useState<string | null>(null);
  const [postLoading, setPostLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [currentVideo, setCurrentVideo] = useState<any>(null);
  const [linkPreviewUrl, setLinkPreviewUrl] = useState<string | null>(null);
  const [linkPreview, setLinkPreview] = useState<LinkPreviewData | null>(null);
  const [linkPreviewLoading, setLinkPreviewLoading] = useState(false);
  const linkPreviewRequestRef = useRef<string | null>(null);

  // const handleTimeChange = (selectedTime) => {
  //   console.log(selectedTime, "selectedTime");
  //   setSchedule(selectedTime.value);
  // };
  // const handleTimeChange = (dateTimeString) => {
  //   setSchedule(dateTimeString); // always the combined value!
  // };

  const postProfile = IS_COMPANY ? currentCompanyLogo : userProfile;
  const postProfileName = IS_COMPANY
    ? (currentCompanyName as string)
    : (userFullName as string);

  const postText = watch("post_text", "");

  useEffect(() => {
    const tmpText = stripHTMLTags(postText);
    setPostTextLength(tmpText.length);
  }, [postText]);

  const clearFormAndState = () => {
    postForm.reset();
    setUploadAssets([]);
    linkPreviewRequestRef.current = null;
    setLinkPreviewUrl(null);
    setLinkPreview(null);
    setLinkPreviewLoading(false);
  };

  const handleUrlPasted = async (url: string) => {
    setLinkPreviewUrl(url);
    setLinkPreviewLoading(true);
    linkPreviewRequestRef.current = url;
    const res: any = await getLinkPreview(url);
    if (linkPreviewRequestRef.current !== url) return; // a newer paste superseded this request
    setLinkPreviewLoading(false);
    if (res.flag && (res.data?.title || res.data?.image)) {
      setLinkPreview({
        url: res.data.url || url,
        title: res.data.title,
        image: res.data.image,
        domain: res.data.domain,
      });
    } else {
      setLinkPreview(null);
    }
  };

  const handleUrlRemoved = () => {
    linkPreviewRequestRef.current = null;
    setLinkPreviewUrl(null);
    setLinkPreview(null);
    setLinkPreviewLoading(false);
  };

  // onUploadImage now creates a MediaAsset for each file.
  const onUploadImage = async (e: any) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    // Limit to 4 files total
    if (files.length + uploadAssets.length > 4) {
      e.target.value = "";
      FlashMessage(
        `Max ${POST_MEDIA_UPLOAD_LIMIT} files can be uploaded`,
        "error"
      );
      return;
    }

    const fileList = Array.from(files as FileList);
    e.target.value = "";

    let newAssets: MediaAsset[] = [];
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      const fileType = file.type;
      const fileSize = file.size;
      // 50MB for video, 25MB for image
      let allowFileSize =
        fileType === "video/mp4" ? 50 * 1024 * 1024 : 25 * 1024 * 1024;

      if (fileSize > allowFileSize) {
        const mb = Math.floor(allowFileSize / 1024 / 1024);
        FlashMessage(`Max ${mb} MB file size allowed`, "error");
        continue;
      }

      const url = URL.createObjectURL(file);
      const asset: MediaAsset = {
        file,
        url,
        type: fileType,
        loadingThumbnails: fileType === "video/mp4",
      };
      if (fileType === "video/mp4") {
        try {
          const thumbs = await generateVideoThumbnails(file);
          asset.thumbnails = thumbs;
          asset.selectedCover = thumbs[0];
        } catch (err) {
          FlashMessage("Error generating video thumbnails", "error");
        } finally {
          asset.loadingThumbnails = false;
        }
      }
      newAssets.push(asset);
    }
    // Append new assets to existing ones
    setUploadAssets((prev) => [...prev, ...newAssets]);
  };

  const blobURLtoBlob = async (blobURL: string): Promise<Blob> => {
    const response = await fetch(blobURL);
    const blob = await response.blob();
    return blob;
  };
  const [userTimezone, setUserTimezone] = useState<string>("");

  useEffect(() => {
    setUserTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  }, []);

  const onSubmit = async (formData: FormFields) => {
    setPostLoading(true);
    let payload = new FormData();
    if (uploadAssets.length > 0) {
      let i = 1;
      for (const asset of uploadAssets) {
        // Append original media
        payload.append(`post_media_${i}`, asset.file);
        if (asset.type === "video/mp4" && asset.selectedCover) {
          const coverBlob =
            asset.selectedCover.startsWith("blob:") ||
              asset.selectedCover.startsWith("data:")
              ? await blobURLtoBlob(asset.selectedCover)
              : asset.selectedCover;
          payload.append(`cover_media_${i}`, coverBlob);
        }
        i++;
      }
    }
    const postBy = IS_COMPANY ? (currentCompanySlug as string) : "user";
    // payload.append("schedule_at", schedule || "");
    payload.append("schedule_at", scheduleValue || "");
    payload.append("post_text", formData.post_text || "");
    payload.append("post_by", postBy);
    payload.append("clientType", "web");
    payload.append("timezone", userTimezone || "");
    payload.append("link_preview_url", linkPreview?.url || "");
    payload.append("link_preview_title", linkPreview?.title || "");
    payload.append("link_preview_image", linkPreview?.image || "");
    payload.append("link_preview_domain", linkPreview?.domain || "");
    try {
      const data = await httpRequest().post(API_URLS.posts, payload);

      if (data.data.status === 200) {
        setPostLoading(false);
        clearFormAndState();
      }
    } catch (error) {
      setPostLoading(false);
      FlashMessage("There was an error posting your update", "error");
    } finally {
      setPostLoading(false);
    }
  };

  const removeMedia = (i) => {
    if (uploadImage) {
      const images = [...uploadImage];
      const imageObj = [...uploadAssets];
      imageObj.splice(i, 1);
      images.splice(i, 1);
      setUploadImage(images);
      setUploadAssets(imageObj);
    } else if (uploadVideo) {
      const videos = [...uploadVideo];
      videos.splice(i, 1);
      setUploadVideo(videos);
    }
    const removeObj = [...uploadAssets];
    removeObj.splice(i, 1);
    setUploadAssets(removeObj);
  };

  const checkKeyDown = (e) => {
    const keyCode = e.keyCode ? e.keyCode : e.which;
    if (keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
    }
  };

  const handleCoverSelect = (cover: { time: number; blob: Blob }) => {
    const url = URL.createObjectURL(cover.blob);

    if (currentVideoIndex !== null) {
      setUploadAssets((prevAssets) =>
        prevAssets.map((asset, idx) => {
          if (idx === currentVideoIndex) {
            return { ...asset, selectedCover: url };
          }
          return asset;
        })
      );
    }
  };

  const invokeBedRock = async () => {
    setLoading(true);
    try {
      const prompt = typeof questions === "string" ? questions.trim() : "";
      if (!prompt) {
        FlashMessage("Please enter a prompt", "error");
        return;
      }

      const payload = {
        question: prompt,
        specification: specify,
        hash: hash,
        words: wordsLimit,
      };
      const response = await httpRequest().post(
        API_URLS.invokeAwsBedRock,
        payload
      );
      const aiText = _.get(response, "data.data", "");
      if (typeof aiText === "string" && aiText.trim()) {
        setResponseAiData(aiText);
      } else {
        FlashMessage(
          _.get(response, "data.message", "Unable to generate content"),
          "error"
        );
      }
    } catch (error: any) {
      FlashMessage(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setQuestion("");
    setResponseAiData("");
    setSpecify("SoundCausal");
    setHash(false);
    setWordLimit(50);
  };
  const isPostButtonDisabled = () => {
    const hasText = stripHTMLTags(postText || "").trim().length > 0;
    const hasMedia = uploadAssets.length > 0;
    return !(hasText || hasMedia);
  };

  const postIncidenceReports = async () => {
    try {
      const outputText =
        typeof responseAiData === "string"
          ? responseAiData.trim()
          : String(responseAiData || "").trim();
      if (!outputText) {
        FlashMessage(
          "Generate AI output first, then you can submit a report.",
          "error"
        );
        return;
      }
      const specification = specify;
      const question = questions;
      const payload = {
        question: question,
        outputText,
        specification: specification,
        hash: hash,
        words: wordsLimit,
      };
      await httpRequest().post(API_URLS.postIncidenceReports, payload);
      FlashMessage("Incidence Report Generate Successfully", "success");
    } catch (error: any) {
      FlashMessage(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong",
        "error"
      );
    }
  };
  const navigate = useNavigate();
  const handleArticle = () => {
    navigate(appRoutes.article.path);
  };

  return (
    <>
      {currentUser && (
        <div className="feed-input-wrapper">
          <FeedLogo
            profileLogo={postProfile}
            name={postProfileName}
            isCompany={currentUser.is_company}
          />
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            <div
              className={`post-wrapper wysiwyg-data ${overflow ? "no-overflow" : ""
                }`}
            >
              <RichTextEditor
                name="post_text"
                validationObj={errors}
                control={control}
                showError={false}
                setOverflow={setOverflow}
                value={AIflag && pendingAiHtml ? pendingAiHtml : postText}
                rules={{
                  validate: {
                    validLength: (value) => {
                      const tmpText = stripHTMLTags(value || "");
                      return (
                        tmpText.length <= 3000 ||
                        "Can not exceed more then 3000 characters"
                      );
                    },
                  },
                }}
                useMention={true}
                AIflag={AIflag}
                onAIApplied={() => {
                  setAIflag(false);
                  setPendingAiHtml("");
                }}
                onUrlPasted={handleUrlPasted}
                watchUrl={linkPreviewUrl}
                onUrlRemoved={handleUrlRemoved}
              />
            </div>
            {_.get(errors, "post_text.message") && (
              <ErrorTextHelper text={_.get(errors, "post_text.message", "")} />
            )}
            <p>{postTextLength}/3000</p>

            <LinkPreviewCard
              preview={linkPreview}
              loading={linkPreviewLoading}
              onRemove={handleUrlRemoved}
            />

            <div className="media-uploaded">
              {uploadAssets.map((asset, i) => (
                <div className="media-src" key={i}>
                  <span className="media-close" onClick={() => removeMedia(i)}>
                    <CancelOut />
                  </span>
                  {asset.type === "video/mp4" ? (
                    asset.loadingThumbnails ? (
                      <div className="video-cover-loading">
                        <CircularProgress size={28} />
                      </div>
                    ) : (
                      <>
                        <div className="video-cover">
                          <Image
                            src={asset.selectedCover || asset.url}
                            alt="video cover"
                          />
                          <span className="play-icon-cover">
                            <i className="fa fa-play"></i>
                          </span>
                        </div>
                        <span
                          onClick={() => {
                            setShow(true);
                            setCurrentVideo(asset.url);
                            setCurrentVideoIndex(i);
                          }}
                          color="secondary"
                          className="cover-btn"
                        >
                          Edit Cover
                        </span>
                      </>
                    )
                  ) : (
                    <Image src={asset.url} alt="media image" />
                  )}
                </div>
              ))}
            </div>
            <div className="feed-button-wrapper">
              <FeedButton
                svg={cameraIcon}
                name="post_media"
                id="create_post"
                type="file"
                form={postForm}
                onUploadImage={onUploadImage}
                value="post_media"
                accept="image/png, image/gif, image/bmp, image/jpeg, video/mp4"
              />

              <ScheduleModel
                open={scheduleShowModel}
                onClose={() => setScheduleShowModal(false)}
                // setSchedule={handleTimeChange}
                setSchedule={(val) => setScheduleValue(val)}
                scheduleValue={scheduleValue}
              />
              {/* <FeedButton
                svg={cameraIcon}
                name="video_cover"
                id="video_cover"
                type="file"
                form={postForm}
                onUploadImage={onUploadCover}
                value="video_cover"
                accept="image/png, image/gif, image/bmp, image/jpeg"
              /> */}
              <Tooltip
                title="Schedule for later"
                placement="top"
                arrow
                className="schedule-post"
              >
                <div
                  onClick={() => setScheduleShowModal(true)}
                  className="action-item-icon"
                >
                  <ScheduleIcon color="primary" />
                </div>
              </Tooltip>
              <Button
                className="write-ai"
                color="secondary"
                onClick={() => {
                  setAIflag(false);
                  setShowAIModal(true);
                }}
              >
                <div className="write-ai-icon">
                  <img src={WriteWithAIEditIcon} alt="write with ai edit" />
                </div>
                &nbsp;Write with AI
              </Button>

              {showAIModal && (
                <Modal
                  title={
                    <>
                      Generate with <EmployHERName /> AI
                    </>
                  }
                  className="ai-model"
                  visible={true}
                  onClose={() => {
                    loading ? setShowAIModal(true) : setShowAIModal(false);
                    handleClear();
                  }}
                  size="large"
                >
                  <div className="ai-output">
                    {loading ? (
                      <div className="load-image">
                        <Image src={output} />
                      </div>
                    ) : responseAiData ? (
                      <textarea
                        className="response"
                        value={responseAiData}
                        onChange={(e) => {
                          setResponseAiData(e?.currentTarget?.value || "");
                        }}
                      />
                    ) : (
                      <>
                        <textarea
                          className="ai-question"
                          id="title"
                          maxLength={150}
                          placeholder="Enter a Prompt here"
                          rows={30}
                          cols={30}
                          value={questions}
                          onKeyDown={(e) => checkKeyDown(e)}
                          onChange={(e) => {
                            setQuestion(e?.currentTarget?.value || "");
                          }}
                        />
                      </>
                    )}
                    {!loading && (
                      <div className="ai-output-actions">
                        <IconButton
                          type="button"
                          size="small"
                          aria-label="Clear AI response"
                          className="ai-output-icon-btn ai-output-delete"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setResponseAiData("");
                            setQuestion("");
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                        <IconButton
                          type="button"
                          size="small"
                          aria-label="Submit incidence report"
                          className="ai-output-icon-btn ai-output-flag"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            postIncidenceReports();
                          }}
                        >
                          <OutlinedFlagOutlinedIcon />
                        </IconButton>
                        <Button
                          className="rephrase"
                          color="secondary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            invokeBedRock();
                          }}
                        >
                          <FlareIcon />
                          &nbsp;GENERATE MAGIC
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className="ai-options">
                    <div className="specification-area">
                      <div className="adjust-tone">Adjust tone</div>
                      <div
                        className="btn-specification"
                        role="group"
                        aria-label="Adjust tone"
                      >
                        {AI_TONE_OPTIONS.map((tone) => {
                          const isActive = specify === tone.value;
                          return (
                            <button
                              key={tone.value}
                              type="button"
                              className={`specification${isActive ? " is-active" : ""
                                }`}
                              disabled={loading}
                              aria-pressed={isActive}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setSpecify(tone.value);
                              }}
                            >
                              {tone.label}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    <div className="main-hash-range">
                      <div className="hash">
                        <Checkbox
                          name="hash"
                          checked={hash}
                          disabled={loading}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setHash(e.target.checked);
                          }}
                          externalLabel={{ label: "Add hashtags" }}
                        />
                      </div>
                      <div className="slider">
                        <div className="count-title">Word count</div>
                        <div className="slider-control">
                          <Slider
                            disabled={loading}
                            value={wordsLimit}
                            min={50}
                            max={300}
                            step={10}
                            onChange={(_, words) =>
                              setWordLimit(words as number)
                            }
                          />
                        </div>
                        <div className="word-count">{wordsLimit} words</div>
                      </div>
                    </div>
                    <div className="ai-modal-footer">
                      <Button
                        color="primary"
                        className="insert-post"
                        type="button"
                        disabled={!responseAiData || loading}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const html = aiTextToQuillHtml(responseAiData);
                          setPendingAiHtml(html);
                          setValue("post_text", html, {
                            shouldDirty: true,
                            shouldTouch: true,
                          });
                          setAIflag(true);
                          setShowAIModal(false);
                          handleClear();
                        }}
                      >
                        Insert post
                      </Button>
                    </div>
                  </div>
                </Modal>
              )}
              <Button
                className="submit-btn"
                loading={postLoading}
                disabled={
                  // uploadImage.length > 0 ||
                  // uploadAssets.length > 0 || postText.length > 0 ? false : true
                  isPostButtonDisabled()
                }
                type="submit"
              >
                {scheduleValue ? "Schedule" : "Post"}
              </Button>

              <Button
                className="write-article-btn"
                onClick={() => {
                  handleArticle();
                }}
                color="secondary"
              >
                Write Article
              </Button>
            </div>
            <CommonVideoModal
              openModal={show}
              videoUrl={currentVideo}
              onClose={() => setShow(false)}
              onCoverSelect={handleCoverSelect}
            />
          </form>
        </div>
      )}
    </>
  );
}

export default FeedPost;
